"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnType = exports.MemberColumnInfo = exports.MembersData = void 0;
class MembersData {
}
exports.MembersData = MembersData;
class MemberColumnInfo {
    constructor(columnName, columnValue, type) {
        this.isVisible = true;
        this.isRequiredInFile = true;
        this.columnName = columnName;
        this.columnValue = columnValue;
        this.type = type;
    }
}
exports.MemberColumnInfo = MemberColumnInfo;
var ColumnType;
(function (ColumnType) {
    ColumnType["TEXT"] = "text";
    ColumnType["NUMBER"] = "number";
    ColumnType["DATE"] = "date";
    ColumnType["BOOLEAN"] = "boolean";
    ColumnType["EMAIL"] = "email";
    ColumnType["RFC"] = "rfc";
    ColumnType["PHONE"] = "phone";
})(ColumnType || (exports.ColumnType = ColumnType = {}));
//# sourceMappingURL=validated-data.js.map